<template>
    <v-app-bar
            :dense="dense"
            app
            :clipped-left="clippedLeft"
            :clipped-right="clippedRight"
            :color="color"
            :dark="dark"
            class="pa-0"
    >
        <v-container class="d-flex align-center pa-0 ma-0" style="max-width: 1920px" fluid>
            <slot name="before-actions">
              <v-btn icon small class="mr-2" @click="reloadPage" title="Επαναφόρτωση">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </slot>
            <v-toolbar-title>
                <portal-target name="toolbar-title"/>
            </v-toolbar-title>
            <v-spacer/>
            <v-toolbar-items class="ml-1">
                <portal-target name="toolbar-items"/>
            </v-toolbar-items>
            <portal-target name="toolbar-actions"/>

        </v-container>
    </v-app-bar>
</template>

<script>
    import {mapGetters, mapMutations} from "vuex";
    export default {
        props:{
            clippedLeft:Boolean,
            clippedRight:Boolean,
            dark:Boolean,
            dense:Boolean,
            showSidebarIcon:Boolean,
            color:String
        },
        name: "Topbar",
        computed: {
            ...mapGetters('layout', [
                    "expandSidebarOnHover",
                    "showSidebar",
                    "isMobile"
                ]
            )
        },
        methods: {
            ...mapMutations('layout', [
                    "toggleExpandOnHover",
                    "toggleSidebar"

                ]
            ),
            reloadPage() {
                window.location.reload();
            }
        }
    }
</script>

<style scoped>

</style>
